import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { useSectionMessagesContext } from 'pages/conversations/pages/search/pages/profile/ui/SectionMessages/context/sectionMessagesContext'
import styles from './styles.module.scss'

export const HeaderDefault = observer(() => {
  const store = useSectionMessagesContext()

  return (
    <div className={styles.wrap}>
      <Button
        disabled={store.loadingOpenConversation}
        typeBtn={'text'}
        contained={'secondary'}
        size={'medium'}
        text={'Open in conversations'}
        iconProps={{
          icon: 'linkExternal',
        }}
        onClick={() => {
          store.openConversation()
        }}
      />
    </div>
  )
})
